var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodiumCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3635 4.48308C28.0863 6.24875 27.5199 11.2481 22.831 11.2228C18.8579 11.2012 18.1971 5.48543 18.1971 5.48543L20.095 3.86348C20.095 3.86348 16.649 2.67112 15.5 0C14.3515 2.67112 10.9055 3.86348 10.9055 3.86348L12.8029 5.48543C12.8029 5.48543 12.1426 11.2012 8.16902 11.2228C3.48011 11.2481 2.91372 6.24875 4.63699 4.48308L0 5.32124L3.45231 20C7.06143 18.0863 11.1577 17.0048 15.5 17.0048C19.8423 17.0048 23.9386 18.0858 27.5477 20L31 5.32124L26.3635 4.48308ZM15.5 13.3475L12.6938 10.467L15.5 7.58647L18.3062 10.467L15.5 13.3475Z",
    fill: "#FFAF10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodiumCrown);
export default __webpack_public_path__ + "static/media/podium-crown.77f81076ae8e7595b0b887d08520608f.svg";
export { ForwardRef as ReactComponent };